import { returnFirstEl as e } from "./common/utils/index.js";
import { t } from "./_plugin-vue_export-helper-BTgDAbhb.js";
import { Fragment as n, computed as r, createBlock as i, createCommentVNode as a, createElementBlock as o, createSlots as s, createVNode as c, guardReactiveProps as l, h as u, markRaw as d, mergeProps as f, nextTick as p, normalizeClass as m, normalizeProps as h, normalizeStyle as g, onMounted as _, openBlock as v, provide as y, reactive as b, ref as x, renderList as S, renderSlot as C, resolveComponent as w, resolveDynamicComponent as T, shallowReactive as E, toHandlers as D, unref as O, watch as k, withCtx as A } from "vue";
//#region components/scroller/modules/core_scroller.vue
var j = {
	__name: "core_scroller",
	props: {
		items: {
			type: Array,
			required: !0
		},
		keyField: {
			type: String,
			default: "id"
		},
		direction: {
			type: String,
			default: "vertical",
			validator: (e) => ["vertical", "horizontal"].includes(e)
		},
		itemSize: {
			type: Number,
			default: null
		},
		minItemSize: {
			type: [Number, String],
			default: null
		},
		sizeField: {
			type: String,
			default: "size"
		},
		buffer: {
			type: Number,
			default: 200
		},
		skipHover: {
			type: Boolean,
			default: !1
		},
		listTag: {
			type: String,
			default: "div"
		},
		itemTag: {
			type: String,
			default: "div"
		},
		listClass: {
			type: [
				String,
				Object,
				Array
			],
			default: ""
		},
		itemClass: {
			type: [
				String,
				Object,
				Array
			],
			default: ""
		}
	},
	emits: [
		"user-position",
		"scroll-start",
		"scroll-end"
	],
	setup(e, { expose: t, emit: s }) {
		let c = e, l = s, u = b(/* @__PURE__ */ new Map()), h = b(/* @__PURE__ */ new Map()), y = x([]), w = x(null), j = x(!1), M = x(null), N = x(null), P = x(null), F = x("top"), I = 0, L = 0, R = !1, z = 0, B = null, V = null, H = 0, U = 0, W = r(() => {
			if (c.itemSize === null) {
				let e = { "-1": { accumulator: 0 } }, t = c.items, n = c.sizeField, r = c.minItemSize, i = 1e4, a = 0, o;
				for (let s = 0, c = t.length; s < c; s++) o = t[s][n] || r, o < i && (i = o), a += o, e[s] = {
					accumulator: a,
					size: o
				};
				return V = i, e;
			}
			return [];
		}), G = r(() => c.items.length && typeof c.items[0] != "object"), K = r(() => {
			let e = {};
			for (let t = 0, n = c.items.length; t < n; t++) e[c.items[t][c.keyField]] = t;
			return e;
		});
		k(W, () => {
			Q(!1);
		}, { deep: !0 }), _(() => {
			p(() => {
				Q(!0), j.value = !0;
			});
		});
		let q = (e, t, n, r, i) => {
			let a = E({
				item: n,
				position: 0,
				nr: d({
					id: U++,
					index: t,
					used: !0,
					key: r,
					type: i
				})
			});
			return e.value.push(a), a;
		}, J = (e, t = !1) => {
			let n = h, r = e.nr.type, i = n.get(r);
			i || (i = [], n.set(r, i)), i.push(e), t || (e.nr.used = !1, e.position = -9999);
		}, Y = () => {
			let e = c.direction === "vertical", t;
			return t = e ? {
				start: M.value.scrollTop,
				end: M.value.scrollTop + M.value.clientHeight
			} : {
				start: M.value.scrollLeft,
				end: M.value.scrollLeft + M.value.clientWidth
			}, t;
		}, X = () => {
			throw setTimeout(() => {
				console.error("It seems the scroller element isn't scrolling, so it tries to render all the items at once.", "Scroller:", M), console.error("Make sure the scroller has a fixed height (or width) and 'overflow-y' (or 'overflow-x') set to 'auto' so it can scroll correctly and only render the items visible in the scroll viewport.");
			}), Error("Rendered items limit reached");
		}, Z = () => {
			y.value.sort((e, t) => e.nr.index - t.nr.index);
		}, Q = (e, t = !1) => {
			let n = c.itemSize, r = V, i = G.value ? null : c.keyField, a = c.items, o = a.length, s = W.value, d = u, f = h, p = y, m = K, g, _, v, b, x;
			if (!o) g = _ = b = x = v = 0;
			else {
				let e = Y();
				if (t) {
					let t = e.start - z.value;
					if (t < 0 && (t = -t), n === null && t < r.value || t < n) return { continuous: !0 };
				}
				z = e.start;
				let i = c.buffer;
				e.start -= i, e.end += i;
				let l = c.direction === "vertical" ? "scrollHeight" : "scrollWidth";
				if (N.value && (e.start -= N.value[l]), P.value && (e.end += P.value[l]), n === null) {
					let t, n = 0, r = o - 1, i = ~~(o / 2), c;
					do
						c = i, t = s[i]?.accumulator, t < e.start ? n = i : i < o - 1 && s[i + 1]?.accumulator > e.start && (r = i), i = ~~((n + r) / 2);
					while (i !== c);
					for (i < 0 && (i = 0), g = i, v = s[o - 1]?.accumulator, _ = i; _ < o && s[_]?.accumulator < e.end; _++);
					for (_ === -1 ? _ = a.length - 1 : (_++, _ > o && (_ = o)), b = I; b < o && s[b]?.accumulator < e.start; b++);
					for (x = b; x < o && s[x]?.accumulator < e.end; x++);
				} else {
					g = ~~(e.start / n);
					let t = g % 1;
					g -= t, _ = Math.ceil(e.end / n), b = Math.max(0, Math.floor(e.start / n)), x = Math.floor(e.end / n), g < 0 && (g = 0), _ > o && (_ = o), b < 0 && (b = 0), x > o && (x = o), v = Math.ceil(o / 1) * n;
				}
			}
			_ - g > 1e3 && X(), H = v;
			let S, C = g <= L && _ >= g;
			if (C) for (let t = 0, n = p.value.length; t < n; t++) S = p.value[t], S?.nr.used && (e && (S.nr.index = m[S.item[i]]), (S.nr.index == null || S.nr.index < g || S.nr.index >= _) && J(S));
			let w = C ? null : /* @__PURE__ */ new Map(), T, E, D;
			for (let e = g; e < _; e++) {
				T = a[e];
				let t = i ? T?.[i] : T;
				if (t == null) throw Error(`Key is ${t} on item (keyField is '${i}')`);
				if (S = d.get(t), !n && !s[e]?.size) {
					S && J(S);
					continue;
				}
				E = T.type;
				let r = f.get(E), o = !1;
				if (!S) C ? S = r && r.length ? r.pop() : q(p, e, T, t, E) : (D = w.get(E) || 0, (!r || D >= r.length) && (S = q(p, e, T, t, E), J(S, !0), r = f.get(E)), S = r[D], w.set(E, D + 1)), d.delete(S.nr.key), S.nr.used = !0, S.nr.index = e, S.nr.key = t, S.nr.type = E, d.set(t, S), o = !0;
				else if (!S.nr.used && (S.nr.used = !0, o = !0, r)) {
					let e = r.indexOf(S);
					e !== -1 && r.splice(e, 1);
				}
				S.item = T, o && (e === a.length - 1 && l("scroll-end"), e === 0 && l("scroll-start")), n === null ? (S.position = s[e - 1]?.accumulator, S.offset = 0) : (S.position = Math.floor(e) * n, S.offset = e % 1 * n);
			}
			return I = g, L = _, clearTimeout(B), B = setTimeout(Z, 300), { continuous: C };
		}, $ = (e) => {
			let t = c.direction === "vertical" ? {
				scroll: "scrollTop",
				start: "top"
			} : {
				scroll: "scrollLeft",
				start: "left"
			}, n = M.value, r = t.scroll;
			n[r] = e;
		}, ee = (e) => {
			let t;
			t = c.itemSize === null ? e > 0 ? W.value[e - 1]?.accumulator : 0 : Math.floor(e) * c.itemSize, $(t);
		}, te = () => {
			let e = M.value;
			F.value !== "middle" && (F.value = "middle", l("user-position", "middle")), e.scrollTop === 0 && (F.value = "top", l("user-position", "top")), e.scrollTop + e.clientHeight === e.scrollHeight && (F.value = "bottom", l("user-position", "bottom")), R || (R = !0, requestAnimationFrame(() => {
				R = !1, Q(!1, !0);
			}));
		};
		return t({
			scrollToItem: ee,
			_updateVisibleItems: Q
		}), (t, r) => (v(), o("div", {
			ref_key: "scroller",
			ref: M,
			class: m(["vue-recycle-scroller", {
				ready: j.value,
				[`direction-${e.direction}`]: !0
			}]),
			onScrollPassive: te
		}, [
			t.$slots.before ? (v(), o("div", {
				key: 0,
				ref_key: "before",
				ref: N,
				"data-qa": "dt-scroller-before",
				class: "vue-recycle-scroller__slot"
			}, [C(t.$slots, "before")], 512)) : a("", !0),
			(v(), i(T(e.listTag), {
				ref: "wrapper",
				style: g({ [e.direction === "vertical" ? "minHeight" : "minWidth"]: `${O(H)}px` }),
				"data-qa": "dt-scroller-item-wrapper",
				class: m(["vue-recycle-scroller__item-wrapper", e.listClass])
			}, {
				default: A(() => [(v(!0), o(n, null, S(y.value, (n) => (v(), i(T(e.itemTag), f({
					key: n.nr.id,
					"data-qa": "dt-scroller-item",
					style: j.value ? {
						transform: `translate${e.direction === "vertical" ? "Y" : "X"}(${n.position}px) translate${e.direction === "vertical" ? "X" : "Y"}(${n.offset}px)`,
						width: void 0,
						height: void 0
					} : null,
					class: ["vue-recycle-scroller__item-view", [e.itemClass, { hover: !e.skipHover && w.value === n.nr.key }]]
				}, D(e.skipHover ? {} : {
					mouseenter: () => {
						w.value = n.nr.key;
					},
					mouseleave: () => {
						w.value = null;
					}
				})), {
					default: A(() => [C(t.$slots, "default", {
						item: n.item,
						index: n.nr.index,
						active: n.nr.used
					})]),
					_: 2
				}, 1040, ["style", "class"]))), 128)), e.items.length ? a("", !0) : C(t.$slots, "empty", { key: 0 })]),
				_: 3
			}, 8, ["style", "class"])),
			t.$slots.after ? (v(), o("div", {
				key: 1,
				ref_key: "after",
				ref: P,
				"data-qa": "dt-scroller-after",
				class: "vue-recycle-scroller__slot"
			}, [C(t.$slots, "after")], 512)) : a("", !0)
		], 34));
	}
}, M = {
	name: "DynamicScroller",
	components: {
		CoreScroller: j,
		DtScrollerItem: {
			name: "DtScrollerItem",
			inject: [
				"vscrollData",
				"vscrollParent",
				"vscrollResizeObserver"
			],
			props: {
				item: { required: !0 },
				watchData: {
					type: Boolean,
					default: !1
				},
				active: {
					type: Boolean,
					required: !0
				},
				index: {
					type: Number,
					default: void 0
				},
				sizeDependencies: {
					type: [Array, Object],
					default: null
				},
				tag: {
					type: String,
					default: "div"
				}
			},
			computed: {
				id() {
					if (this.vscrollData.simpleArray) return this.index;
					if (this.vscrollData.keyField in this.item) return this.item[this.vscrollData.keyField];
					throw Error(`keyField '${this.vscrollData.keyField}' not found in your item. You should set a valid keyField prop on your Scroller`);
				},
				size() {
					return this.vscrollData.sizes[this.id] || 0;
				},
				finalActive() {
					return this.active && this.vscrollData.active;
				}
			},
			watch: {
				watchData: "updateWatchData",
				id(t, n) {
					if (e(this.$el).$_vs_id = this.id, this.size || this.onDataUpdate(), this.$_sizeObserved) {
						let e = this.vscrollData.sizes[n], r = this.vscrollData.sizes[t];
						e != null && e !== r && this.applySize(e);
					}
				},
				finalActive(e) {
					this.size || (e ? this.vscrollParent.$_undefinedMap[this.id] || (this.vscrollParent.$_undefinedSizes++, this.vscrollParent.$_undefinedMap[this.id] = !0) : this.vscrollParent.$_undefinedMap[this.id] && (this.vscrollParent.$_undefinedSizes--, this.vscrollParent.$_undefinedMap[this.id] = !1)), this.vscrollResizeObserver ? e ? this.observeSize() : this.unobserveSize() : e && this.$_pendingVScrollUpdate === this.id && this.updateSize();
				}
			},
			created() {
				if (!this.$isServer && (this.$_forceNextVScrollUpdate = null, this.updateWatchData(), !this.vscrollResizeObserver)) for (let e in this.sizeDependencies) this.$watch(() => this.sizeDependencies[e], this.onDataUpdate);
			},
			mounted() {
				this.finalActive && (this.updateSize(), this.observeSize());
			},
			beforeUnmount() {
				this.unobserveSize();
			},
			methods: {
				updateSize() {
					this.finalActive ? this.$_pendingSizeUpdate !== this.id && (this.$_pendingSizeUpdate = this.id, this.$_forceNextVScrollUpdate = null, this.$_pendingVScrollUpdate = null, this.computeSize(this.id)) : this.$_forceNextVScrollUpdate = this.id;
				},
				updateWatchData() {
					this.watchData && !this.vscrollResizeObserver ? this.$_watchData = this.$watch("item", () => {
						this.onDataUpdate();
					}, { deep: !0 }) : this.$_watchData && (this.$_watchData(), this.$_watchData = null);
				},
				onVscrollUpdate({ force: e }) {
					!this.finalActive && e && (this.$_pendingVScrollUpdate = this.id), (this.$_forceNextVScrollUpdate === this.id || e || !this.size) && this.updateSize();
				},
				onDataUpdate() {
					this.updateSize();
				},
				computeSize(t) {
					this.$nextTick(() => {
						if (this.id === t) {
							let t = e(this.$el).offsetWidth, n = e(this.$el).offsetHeight;
							this.applyWidthHeight(t, n);
						}
						this.$_pendingSizeUpdate = null;
					});
				},
				applyWidthHeight(e, t) {
					let n = ~~(this.vscrollParent.direction === "vertical" ? t : e);
					n && this.size !== n && this.applySize(n);
				},
				applySize(e) {
					this.vscrollParent.$_undefinedMap[this.id] && (this.vscrollParent.$_undefinedSizes--, this.vscrollParent.$_undefinedMap[this.id] = void 0), this.vscrollData.sizes[this.id] = e;
				},
				observeSize() {
					this.vscrollResizeObserver && (this.$_sizeObserved || (this.vscrollResizeObserver.observe(e(this.$el)), this.$el.$_vs_id = this.id, this.$el.$_vs_onResize = this.onResize, this.$_sizeObserved = !0));
				},
				unobserveSize() {
					this.vscrollResizeObserver && this.$_sizeObserved && (this.vscrollResizeObserver.unobserve(e(this.$el)), this.$el.$_vs_onResize = void 0, this.$_sizeObserved = !1);
				},
				onResize(e, t, n) {
					this.id === e && this.applyWidthHeight(t, n);
				}
			},
			render() {
				return u(this.tag, this.$slots.default());
			}
		}
	},
	provide() {
		return typeof ResizeObserver < "u" && (this.$_resizeObserver = new ResizeObserver((e) => {
			requestAnimationFrame(() => {
				if (Array.isArray(e)) {
					for (let t of e) if (t.target && t.target.$_vs_onResize) {
						let e, n;
						if (t.borderBoxSize) {
							let r = t.borderBoxSize[0];
							e = r.inlineSize, n = r.blockSize;
						} else e = t.contentRect.width, n = t.contentRect.height;
						t.target.$_vs_onResize(t.target.$_vs_id, e, n);
					}
				}
			});
		})), {
			vscrollData: this.vscrollData,
			vscrollParent: this,
			vscrollResizeObserver: this.$_resizeObserver
		};
	},
	inheritAttrs: !1,
	props: {
		items: {
			type: Array,
			required: !0
		},
		dynamic: {
			type: Boolean,
			default: !1
		},
		keyField: {
			type: String,
			default: "id"
		},
		direction: {
			type: String,
			default: "vertical",
			validator: (e) => ["vertical", "horizontal"].includes(e)
		},
		listTag: {
			type: String,
			default: "div"
		},
		itemTag: {
			type: String,
			default: "div"
		},
		minItemSize: { type: [Number, String] }
	},
	data() {
		return { vscrollData: {
			active: !0,
			sizes: {},
			keyField: this.keyField,
			simpleArray: !1
		} };
	},
	computed: {
		simpleArray() {
			return this.items.length && typeof this.items[0] != "object";
		},
		itemsWithSize() {
			let e = [], { items: t, keyField: n, simpleArray: r } = this, i = this.vscrollData.sizes, a = t.length;
			for (let o = 0; o < a; o++) {
				let a = t[o], s = r ? o : a[n], c = i[s];
				c === void 0 && !this.$_undefinedMap[s] && (c = 0), e.push({
					item: a,
					[n]: s,
					size: c
				});
			}
			return e;
		}
	},
	watch: {
		simpleArray: {
			handler(e) {
				this.vscrollData.simpleArray = e;
			},
			immediate: !0
		},
		itemsWithSize(t, n) {
			let r = e(this.$el).scrollTop, i = 0, a = 0, o = Math.min(t.length, n.length);
			for (let e = 0; e < o && !(i >= r); e++) i += n[e].size || this.minItemSize, a += t[e].size || this.minItemSize;
			let s = a - i;
			s !== 0 && (e(this.$el).scrollTop += s);
		}
	},
	beforeCreate() {
		this.$_updates = [], this.$_undefinedSizes = 0, this.$_undefinedMap = {};
	},
	activated() {
		this.vscrollData.active = !0;
	},
	deactivated() {
		this.vscrollData.active = !1;
	},
	methods: {
		dynamicScrollerUpdateItems() {
			let e = this.$refs.scroller;
			e && e._updateVisibleItems(!0);
		},
		dynamicScrollerUpdateItemsFromBottom() {
			let e = this.$refs.scroller;
			e && e._updateVisibleItems(!1, !0);
		},
		scrollToItem(e) {
			let t = this.$refs.scroller;
			t && t.scrollToItem(e);
		},
		scrollToBottom() {
			if (this.$_scrollingToBottom) return;
			this.$_scrollingToBottom = !0;
			let t = e(this.$el);
			this.$nextTick(() => {
				t.scrollTop = t.scrollHeight + 5e3;
				let e = () => {
					t.scrollTop = t.scrollHeight + 5e3, requestAnimationFrame(() => {
						t.scrollTop = t.scrollHeight + 5e3, this.$_undefinedSizes === 0 ? this.$_scrollingToBottom = !1 : requestAnimationFrame(e);
					});
				};
				requestAnimationFrame(e);
			});
		}
	}
};
function N(e, t, n, r, a, o) {
	let u = w("dt-scroller-item"), d = w("core-scroller");
	return v(), i(d, f({
		ref: "scroller",
		items: o.itemsWithSize,
		"min-item-size": n.minItemSize,
		direction: n.direction,
		"key-field": n.keyField,
		"list-tag": n.listTag,
		"item-tag": n.itemTag
	}, e.$attrs), s({
		default: A(({ item: t, index: n, active: r }) => [c(u, {
			item: t,
			active: r,
			"size-dependencies": [t.message],
			"data-index": n
		}, {
			default: A(() => [C(e.$slots, "default", h(l({
				item: t.item,
				index: n,
				active: r,
				itemWithSize: t
			})))]),
			_: 2
		}, 1032, [
			"item",
			"active",
			"size-dependencies",
			"data-index"
		])]),
		_: 2
	}, [
		e.$slots.before ? {
			name: "before",
			fn: A(() => [C(e.$slots, "before")]),
			key: "0"
		} : void 0,
		e.$slots.empty ? {
			name: "empty",
			fn: A(() => [C(e.$slots, "empty")]),
			key: "1"
		} : void 0,
		e.$slots.after ? {
			name: "after",
			fn: A(() => [C(e.$slots, "after")]),
			key: "2"
		} : void 0
	]), 1040, [
		"items",
		"min-item-size",
		"direction",
		"key-field",
		"list-tag",
		"item-tag"
	]);
}
var P = /* @__PURE__ */ t(M, [["render", N]]), F = /* @__PURE__ */ Object.assign({ name: "DtScroller" }, {
	__name: "scroller",
	props: {
		buffer: {
			type: Number,
			default: 200
		},
		direction: {
			type: String,
			default: "vertical",
			validator: (e) => ["vertical", "horizontal"].includes(e)
		},
		dynamic: {
			type: Boolean,
			default: !1
		},
		itemSize: {
			type: Number,
			default: null
		},
		itemTag: {
			type: String,
			default: "div"
		},
		items: {
			type: Array,
			required: !0
		},
		keyField: {
			type: String,
			default: "id"
		},
		listTag: {
			type: String,
			default: "div"
		},
		minItemSize: {
			type: [Number, String],
			default: null
		},
		scrollerHeight: {
			type: [String, Number],
			default: "100%"
		},
		scrollerWidth: {
			type: [String, Number],
			default: "100%"
		}
	},
	emits: [
		"user-position",
		"scroll-start",
		"scroll-end"
	],
	setup(e, { expose: t, emit: n }) {
		let a = e;
		y("emit", n);
		let o = x(null), c = r(() => ({
			width: typeof a.scrollerWidth == "number" ? `${a.scrollerWidth}px` : a.scrollerWidth,
			height: typeof a.scrollerHeight == "number" ? `${a.scrollerHeight}px` : a.scrollerHeight
		}));
		k(a, () => {
			m();
		}, {
			deep: !0,
			immediate: !0
		});
		function u() {
			o.value && o.value.scrollToBottom();
		}
		function d(e) {
			o.value && o.value.scrollToItem(e);
		}
		function f() {
			o.value && (a.dynamic ? o.value.dynamicScrollerUpdateItems() : o.value._updateVisibleItems(!0));
		}
		function p() {
			o.value && (a.dynamic ? o.value.dynamicScrollerUpdateItemsFromBottom() : o.value._updateVisibleItems(!1, !0));
		}
		function m() {
			a.dynamic && !a.minItemSize && console.error("scroller error: 'minItemSize' is required on 'dynamic' mode."), !a.dynamic && !a.itemSize && console.error("scroller error: 'itemSize' is required.");
		}
		return t({
			scrollToBottom: u,
			scrollToItem: d,
			updateItems: f,
			updateItemsFromBottom: p
		}), (t, n) => (v(), i(T(e.dynamic ? P : j), {
			ref_key: "scroller",
			ref: o,
			"data-qa": "dt-scroller",
			items: e.items,
			"item-size": e.itemSize,
			"min-item-size": e.minItemSize,
			buffer: e.buffer,
			direction: e.direction,
			"key-field": e.keyField,
			"list-tag": e.listTag,
			"item-tag": e.itemTag,
			style: g(c.value),
			tabindex: "0",
			onUserPosition: n[0] || (n[0] = (e) => t.$emit("user-position", e)),
			onScrollStart: n[1] || (n[1] = (e) => t.$emit("scroll-start")),
			onScrollEnd: n[2] || (n[2] = (e) => t.$emit("scroll-end"))
		}, s({
			default: A(({ item: e, index: n, active: r }) => [C(t.$slots, "default", h(l({
				item: e,
				index: n,
				active: r
			})))]),
			_: 2
		}, [
			t.$slots.before ? {
				name: "before",
				fn: A(() => [C(t.$slots, "before")]),
				key: "0"
			} : void 0,
			t.$slots.empty ? {
				name: "empty",
				fn: A(() => [C(t.$slots, "empty")]),
				key: "1"
			} : void 0,
			t.$slots.after ? {
				name: "after",
				fn: A(() => [C(t.$slots, "after")]),
				key: "2"
			} : void 0
		]), 1064, [
			"items",
			"item-size",
			"min-item-size",
			"buffer",
			"direction",
			"key-field",
			"list-tag",
			"item-tag",
			"style"
		]));
	}
});
//#endregion
export { F as t };

//# sourceMappingURL=scroller-BDgM9Yzb.js.map